<template>
  <div>
    <div class="pg-head">
      <div class="pg-ico"><span class="mdi mdi-book-account"></span></div>
      <div>
        <div class="id-h1">{{ $t('nav.customerCourse') }}</div>
        <div class="pg-sub">{{ $t('nav.customerCourse') }}</div>
      </div>
    </div>

    <!-- server-side search + pagination preserved (getCustomerCourseList / tableOptions / totalItems / search watcher) -->
    <div class="grid-toolbar">
      <label class="grid-search"><span class="mdi mdi-magnify"></span>
        <input class="id-input" v-model="search" :placeholder="$t('btn.search')" /></label>
      <id-select class="grid-filter" v-model="filterCoursetype" :placeholder="$t('customerCourse.allTypes')" @update:model-value="applyFilter"
        :options="[{ value: '', label: $t('customerCourse.allTypes') }, { value: 'Monthly', label: 'Monthly' }, { value: 'Limited', label: 'Limited' }]"></id-select>
      <id-select class="grid-filter" v-model="filterPaid" :placeholder="$t('customerCourse.allPayments')" @update:model-value="applyFilter"
        :options="[{ value: '', label: $t('customerCourse.allPayments') }, { value: '1', label: $t('customerCourse.paid') }, { value: '0', label: $t('customerCourse.unpaid') }]"></id-select>
      <id-select class="grid-filter" v-model="filterPromotion" :placeholder="$t('customerCourse.allPromotions')" @update:model-value="applyFilter"
        :options="[{ value: '', label: $t('customerCourse.allPromotions') }, { value: '1', label: $t('customerCourse.promotionBadge') }, { value: '0', label: $t('customerCourse.notPromo') }]"></id-select>
      <span class="grid-spacer"></span>
      <span v-if="viewers.length" class="pres-viewers"
        v-hint="$t('presence.viewersHint', { names: viewers.join(', ') })"
        :aria-label="$t('presence.viewersHint', { names: viewers.join(', ') })">
        <span class="mdi mdi-account-eye"></span>{{ viewers.length }}
      </span>
      <button class="id-btn id-btn-ghost id-btn-sm" @click="expiryEdit = null; expiryDialog = true"><span class="mdi mdi-calendar-expand-horizontal"></span> {{ $t('expiryReq.openDialog') }}</button>
      <button class="id-btn id-btn-ghost id-btn-sm" @click="expiryList = true"><span class="mdi mdi-calendar-clock"></span> {{ $t('expiryReq.openList') }}
        <span v-if="isHead && pendingExpiry > 0" class="badge badge-warning">{{ pendingExpiry }}</span></button>
      <button class="id-btn id-btn-ghost id-btn-sm" @click="openPriceCatalog"><span class="mdi mdi-cash-edit"></span> {{ $t('customerCourse.priceCatalog') }}</button>
      <button class="id-btn id-btn-primary id-btn-sm" @click="dialog = true"><span class="mdi mdi-plus"></span> {{ $t('btn.newCourse') }}</button>
    </div>
    <div class="scard" style="padding:14px">
      <div style="overflow-x:auto">
        <table class="idt">
          <thead>
            <tr>
              <th v-for="h in headers" :key="h.key"
                :class="{ 'idt-action': ['view', 'edit', 'delete', 'finish'].includes(h.key), 'idt-sortable': h.sortable !== false, 'idt-sorted': $sortDir(tableOptions.sortBy, h.key) }"
                :style="{ textAlign: (h.align === 'center' || h.align === 'end') ? 'center' : 'left' }" @click="applySort(h)">
                {{ h.title }}
                <span v-if="$sortDir(tableOptions.sortBy, h.key)" class="mdi idt-sort-ico" :class="$sortDir(tableOptions.sortBy, h.key) === 'desc' ? 'mdi-arrow-down' : 'mdi-arrow-up'"></span>
              </th>
            </tr>
          </thead>
          <tbody v-if="loadingCustomerCourse" class="id-fade-in" key="sk">
            <tr v-for="i in 6" :key="'sk' + i">
              <td v-for="h in headers" :key="h.key"><div class="id-skel" style="height:18px"></div></td>
            </tr>
          </tbody>
          <tbody v-else class="id-fade-in" :key="tableOptions.page">
            <tr v-for="item in courselist" :key="item.courserefer">
              <td v-for="h in headers" :key="h.key" :class="{ 'idt-action': ['view', 'edit', 'delete', 'finish'].includes(h.key) }" :style="{ textAlign: (h.align === 'center' || h.align === 'end') ? 'center' : 'left' }">
                <template v-if="h.key === 'courserefer'"><span class="id-copy">{{ item.courserefer }}<span class="mdi mdi-content-copy id-copy-btn" v-hint="$t('btn.copy')" @click="copyToClipboard(item.courserefer)"></span><span v-if="editors[item.courserefer] && editors[item.courserefer] !== myUsername" class="pres-lock" v-hint="$t('presence.editingHint', { name: editors[item.courserefer] })" :aria-label="$t('presence.editingHint', { name: editors[item.courserefer] })"><span class="mdi mdi-pencil-circle"></span></span></span></template>
                <template v-else-if="h.key === 'coursename'">{{ item.coursename }}<span v-if="item.is_promotion == 1" class="badge badge-info" style="margin-left:6px"><span class="mdi mdi-tag-heart"></span> {{ $t('customerCourse.promotionBadge') }}</span></template>
                <template v-else-if="h.key === 'startdate'">{{ format_date(item.startdate) }}</template>
                <template v-else-if="h.key === 'expiredate'"><span :style="{ color: (item.expiredate != null && isExpiredDate(item.expiredate)) ? 'var(--c-error)' : '' }">{{ expireDateLeft(item.expiredate) }}</span></template>
                <template v-else-if="h.key === 'remaining'">
                  <span v-if="item.coursetype === 'Monthly'" class="badge badge-primary">{{ $t('home.monthly') }}</span>
                  <span v-else-if="item.remaining !== null && item.remaining !== ''" class="badge" :class="Number(item.remaining) <= 2 ? 'badge-warning' : 'badge-primary'">{{ item.remaining }} {{ $t('common.times') }}</span>
                  <span v-else>-</span>
                </template>
                <template v-else-if="h.key === 'paid'">
                  <span v-if="item.paid == 1" class="badge badge-success">{{ $t('customerCourse.paid') }}</span>
                  <span v-else class="badge badge-error">{{ $t('customerCourse.unpaid') }}</span>
                </template>
                <template v-else-if="h.key === 'view'"><span class="mdi mdi-history" style="color:var(--c-primary);cursor:pointer;font-size:20px" @click="showCourseInfo(item)"></span></template>
                <template v-else-if="h.key === 'edit'"><span class="mdi mdi-pencil" style="color:var(--c-info);cursor:pointer;font-size:20px" @click="editItem(item)"></span></template>
                <template v-else-if="h.key === 'delete'"><span class="mdi mdi-delete-forever" style="color:var(--c-error);cursor:pointer;font-size:20px" @click="deleteItem(item)"></span></template>
                <template v-else-if="h.key === 'finish'"><span class="mdi mdi-check" style="color:var(--c-success);cursor:pointer;font-size:20px" @click="finishCourse(item)"></span></template>
                <template v-else>{{ item[h.key] }}</template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="!loadingCustomerCourse && courselist.length === 0" class="grid-empty"><span class="mdi mdi-book-off-outline"></span>{{ $t('common.noData') }}</div>
      <id-grid-footer v-if="totalItems > 0"
        :page="tableOptions.page"
        :page-count="Math.max(1, Math.ceil(totalItems / tableOptions.itemsPerPage))"
        :per-page="tableOptions.itemsPerPage" :total="totalItems"
        @update:page="(p) => { tableOptions.page = p; getCustomerCourseList(true); }"
        @update:per-page="(n) => { tableOptions.itemsPerPage = n; tableOptions.page = 1; getCustomerCourseList(true); }" />
    </div>

    <!-- add / edit dialog -->
    <id-modal v-model="dialog" size="xl" icon="mdi-book-plus-multiple" :title="formTitle" persistent>
      <v-form ref="courseform">
        <div class="modal-sec"><span class="mdi mdi-book-open-variant"></span> {{ $t('courseHistory.courseInfo') }}</div>
        <div v-if="otherEditor" class="pres-warn">
          <span class="mdi mdi-alert-outline"></span>
          {{ $t('presence.alsoEditing', { name: otherEditor }) }}
        </div>
        <div class="t-cap" style="margin-bottom:4px">{{ $t('courseHistory.courseRefer') }}: <b>{{ editedItem.courserefer || $t('customerCourse.autoGenerated') }}</b></div>
        <!-- แทนบรรทัด course_user เดิมที่ยัดทุกอย่างรวมกัน — แยก "ถืออยู่ตอนนี้" กับ "เคยใช้" -->
        <course-holders-line :holders="courseHolders" :ever-used="courseEverUsed" />
        <div class="t-cap" v-if="editedIndex > -1" style="margin-bottom:12px">
          {{ $t('table.createBy') }}: <b>{{ editedItem.createby || '-' }}</b> · {{ format_datetime(editedItem.createdate) || '-' }}
          <template v-if="editedItem.updateby">&nbsp;·&nbsp; {{ $t('table.updateBy') }}: <b>{{ editedItem.updateby }}</b> · {{ format_datetime(editedItem.editdate) || '-' }}</template>
        </div>
        <div class="form-grid-3">
          <div class="field"><label>{{ $t('table.courseName') }} <span class="req">*</span></label>
            <id-select :model-value="editedItem.course ? editedItem.course.courseid : ''" :disabled="editedIndex > -1"
              searchable :placeholder="$t('common.selectCourse')"
              :options="courseLookup.map(c => ({ value: c.courseid, label: c.coursename }))"
              @update:model-value="onSelectCourse"></id-select></div>
          <div class="field"><label>{{ $t('table.courseType') }}</label>
            <id-select v-model="editedItem.coursetype" :disabled="editedIndex !== -1" :placeholder="$t('common.select')" :options="['Monthly', 'Limited']" @update:model-value="onCourseTypeChange"></id-select></div>
          <!-- period เดิมล็อกตายตอนแก้ไขทุกบทบาท (backend ก็ทิ้งค่าเงียบ ๆ) — 17 ส.ค. เจ้าของเคาะ:
               head แก้ได้ตลอด · แอดมินแก้ได้เฉพาะใบที่ยังไม่ถูกจอง/ยังไม่ activate (scheduleLocked) -->
          <div class="field"><label>{{ $t('customerCourse.period') }}</label>
            <id-select v-model="editedItem.period" :disabled="scheduleLocked" :placeholder="$t('common.select')" :options="[1, 2, 3, 6, 12]" @update:model-value="maybeAutofillPrice"></id-select></div>
        </div>

        <div class="form-grid-3" style="margin-top:14px">
          <div class="field"><label>{{ $t('table.remaining') }}</label>
            <input class="id-input" v-model="editedItem.remaining"
              :readonly="editedIndex !== -1" :disabled="editedItem.coursetype === 'Monthly'"
              :placeholder="editedItem.coursetype === 'Monthly' ? $t('customerCourse.unlimited') : ''"
              @change="maybeAutofillPrice"></div>
          <div class="field"><label>{{ $t('table.startDate') }}</label>
            <id-date v-model="editedItem.startdate" :disabled="scheduleLocked" :placeholder="$t('common.selectDate')" @update:model-value="onChangeStartDate"></id-date></div>
          <div class="field"><label>{{ $t('table.expireDate') }}</label>
            <id-date v-model="editedItem.expiredate" :disabled="scheduleLocked" :mindate="editedItem.startdate" :placeholder="$t('common.selectDate')"></id-date></div>
        </div>
        <div v-if="expiryChanged" class="field full" style="margin-top:14px">
          <label>{{ $t('customerCourse.expiryReason') }}</label>
          <input class="id-input" v-model="expiryReason" maxlength="500" :placeholder="$t('customerCourse.expiryReasonPh')">
          <div class="t-cap" style="margin-top:4px">{{ $t('customerCourse.expiryReasonHint') }}</div></div>
        <div v-if="scheduleLocked" class="t-cap" style="margin-top:6px">
          <span class="mdi mdi-lock-outline"></span> {{ $t('customerCourse.scheduleLockedHint') }}
        </div>
        <label class="id-cbx" style="margin-top:16px" @click="editedItem.enable_double_booking = editedItem.enable_double_booking == 1 ? 0 : 1">
          <span class="idsw" :class="{ on: editedItem.enable_double_booking == 1 }"><span class="track"></span><span class="thumb"></span></span>
          <span>{{ $t('customerCourse.doubleBookingNote') }}
            <b v-if="editedItem.enable_double_booking == 1" class="double-booking-highlight">{{ $t('customerCourse.doubleBookingMore') }}</b>
            {{ $t('customerCourse.doubleBookingUnit') }}</span>
        </label>

        <div class="modal-sec mt"><span class="mdi mdi-cash-multiple"></span> {{ $t('table.payment') }}</div>
        <!-- row 1: paid + promotion checkboxes — grid cells so each keeps a fixed column
             (the "จ่ายแล้ว/ยังไม่จ่าย" label width no longer shifts the fields beside it) -->
        <div class="form-grid-3" style="align-items:center;margin-top:4px">
          <label class="id-cbx" @click="togglePaid">
            <span class="id-check" :class="{ on: editedItem.paid == 1 }"><span class="mdi mdi-check"></span></span>
            {{ editedItem.paid ? $t('customerCourse.paid') : $t('customerCourse.unpaid') }}
          </label>
          <label class="id-cbx" @click="editedItem.is_promotion = editedItem.is_promotion == 1 ? 0 : 1">
            <span class="id-check" :class="{ on: editedItem.is_promotion == 1 }"><span class="mdi mdi-check"></span></span>
            <span><span class="mdi mdi-tag-heart" style="color:var(--c-secondary)"></span> {{ $t('customerCourse.promotion') }}</span>
          </label>
        </div>
        <!-- row 2: price + pay date + payment method — pay date & method editable only after "paid" -->
        <div class="form-grid-3" style="align-items:end;margin-top:14px">
          <div class="field"><label>{{ $t('table.price') }} <span class="req">*</span></label>
            <id-money v-model="editedItem.price" placeholder="0.00" @update:model-value="onPriceChanged"></id-money></div>
          <div class="field"><label>{{ $t('customerCourse.payDate') }} <span v-if="editedItem.paid == 1" class="req">*</span></label>
            <!-- ไม่มี :mindate — วันที่ชำระเป็นข้อเท็จจริงว่าจ่ายเมื่อไหร่ ลูกค้าจ่ายก่อนวันเริ่มคอร์ส
                 (มัดจำ/จ่ายล่วงหน้า) หรือแอดมินมาบันทึกย้อนหลังก็ได้ ต้องเลือกได้ทุกวัน
                 อีกสองจอที่รับเงิน (PrivateBookingEditDialog / BookingManagement) ก็ไม่จำกัดเช่นกัน -->
            <id-date v-model="editedItem.paydate" :placeholder="$t('common.selectDate')" :disabled="editedItem.paid != 1"></id-date></div>
          <div class="field"><label>{{ $t('customerCourse.paymentMethod') }} <span v-if="editedItem.paid == 1" class="req">*</span></label>
            <id-select v-model="editedItem.paymentmethod" :placeholder="$t('customerCourse.selectPayment')" :options="paymentOptions" :disabled="editedItem.paid != 1"
              @update:model-value="onPaymentMethodChanged"></id-select></div>
        </div>
        <!-- row 3: ค่าธรรมเนียมการชำระเงิน — อยู่ใต้ช่องราคาโดยตรง (คอลัมน์แรกของ grid เดียวกัน)
             อ่านอย่างเดียวโดยปริยาย: ระบบคำนวณให้จาก ราคา x อัตราค่าธรรมเนียมบัตรเครดิต เมื่อเลือก
             "บัตรเครดิต" วิธีอื่นเป็น 0.00 — แอดมินกดดินสอเพื่อขอแก้เองได้หลังยืนยันใน dialog -->
        <!-- เจ้าของสั่งปรับ layout 17 ส.ค.: สลิปขึ้นมาอยู่ข้างค่าธรรมเนียมในแถวเดียวกัน และ
             คำอธิบายค่าธรรมเนียม (t-cap) ย้ายเข้าไปอยู่ "ใต้ช่องค่าธรรมเนียม" ใน .field เดียวกัน
             เพื่อให้อ่านออกว่าเป็น caption ของช่องนี้ ไม่ใช่คอลัมน์แยก — โครงเดียวกับ
             PrivateBookingEditDialog ต้องแก้คู่กันเสมอ (กติกา 3 หน้ารับเงินหน้าตาตรงกัน)
             align-items:start เพราะสอง field สูงไม่เท่ากันแล้ว (ฝั่งซ้ายมี caption ต่อท้าย) -->
        <div class="form-grid-3" style="align-items:start;margin-top:14px">
          <div class="field">
            <label>{{ $t('customerCourse.paymentFee') }} <span v-if="editedItem.paid == 1" class="req">*</span></label>
            <div class="fee-wrap">
              <id-money v-model="editedItem.payment_fee" placeholder="0.00" :readonly="!feeManualOverride"
                :class="{ 'fee-readonly': !feeManualOverride }"></id-money>
              <button v-if="!feeManualOverride" type="button" class="fee-btn" v-hint="$t('customerCourse.paymentFeeEditBtn')"
                :aria-label="$t('customerCourse.paymentFeeEditBtn')" @click="showFeeEditConfirm = true">
                <span class="mdi mdi-pencil-outline"></span>
              </button>
              <button v-else type="button" class="fee-btn" v-hint="$t('customerCourse.paymentFeeResetBtn')"
                :aria-label="$t('customerCourse.paymentFeeResetBtn')" @click="resetFeeToAuto">
                <span class="mdi mdi-restore"></span>
              </button>
            </div>
            <div class="t-cap" style="line-height:1.5;margin-top:4px">
              <span v-if="feeManualOverride" style="color:var(--c-warning)">
                <span class="mdi mdi-pencil"></span>
                {{ $t('customerCourse.paymentFeeManualHint', { amount: formatMoney(computedPaymentFee) }) }}
              </span>
              <span v-else-if="editedItem.paymentmethod === 'credit'">
                <span class="mdi mdi-information-outline"></span>
                {{ $t('customerCourse.paymentFeeAutoHint', { pct: feeRatePercentLabel }) }}
              </span>
              <span v-else>
                <span class="mdi mdi-information-outline"></span>
                {{ $t('customerCourse.paymentFeeNoneHint') }}
              </span>
            </div>
          </div>
          <!-- slip upload is ALWAYS visible but disabled until "paid" is ticked (uploading a
               slip only makes sense once payment is recorded); SlipOK verification still runs
               only for bank transfer — see the note + backend gate -->
          <!-- multi-slip: รายการสลิปแทน input เดี่ยว + ลิงก์ "ดูสลิป" เดิม (MULTI_SLIP_DESIGN.md)
               เลือกไฟล์ = เข้าคิว (แสดงเป็นแถว "รอแนบตอนบันทึก") — อัพโหลด+ตรวจจริงตอนกด "บันทึก"
               เท่านั้น (เจ้าของเคาะ 2026-08-21) ไฟล์ทั้งคิวไปกับ FormData ของ add/update ในคำขอเดียว
               กับ paid/ราคา จึงไม่มีสถานะครึ่งทาง · ใบเดิมโชว์สลิปที่บันทึกแล้วจาก /slipImages ด้วย
               (การลบยังมีผลทันทีหลัง confirm — soft delete + ลง audit) -->
          <div class="field" style="grid-column:span 2">
            <slip-list-panel :context="editedIndex > -1 ? 'course' : null" :refer="editedItem.courserefer"
              :preloaded="slipPreload"
              :pending-files="pendingSlips" @update:pending-files="v => pendingSlips = v"
              :pending-deletes="pendingSlipDeletes" @update:pending-deletes="v => pendingSlipDeletes = v"
              :disabled="editedItem.paid != 1" :payment-method="editedItem.paymentmethod"
              :price-override="editedItem.price"
              @error="msg => $emit('onErrorHandler', msg)"></slip-list-panel>
          </div>
        </div>
        <div class="field full" style="margin-top:14px"><label>{{ $t('customerCourse.shortNote') }}</label>
          <textarea class="id-input id-textarea" v-model="editedItem.shortnote" maxlength="500"></textarea>
          <div class="t-cap" style="text-align:right;margin-top:4px">{{ (editedItem.shortnote || '').length }}/500</div></div>

        <template v-if="editedIndex > -1">
          <div class="modal-sec mt"><span class="mdi mdi-history"></span> {{ $t('table.courseUsageHistory') }}</div>
          <div class="id-modal-grid"><div class="id-modal-grid-scroll" style="max-height:30vh">
            <v-data-table :headers="CourseUsingHeaders" :items="CourseUsingtList" density="compact" :items-per-page="1000">
              <template v-slot:item.index="{ item }">{{ CourseUsingtList.indexOf(item) + 1 }}</template>
              <template v-slot:item.classdate="{ item }"><p>{{ format_date(item.classdate) }} </p></template>
              <template v-slot:item.createby="{ item }"><booked-by-cell :name="item.createby" :role="item.createby_role" :at="item.createdate" /></template>
              <template v-slot:item.lastedit_by="{ item }"><booked-by-cell :name="item.lastedit_by" :role="item.lastedit_role" :at="item.lastedit_at" /></template>
              <template #bottom></template>
            </v-data-table>
          </div></div>
        </template>
      </v-form>
      <template #footer>
        <button class="id-btn id-btn-ghost" @click="close">{{ $t('btn.cancel') }}</button>
        <!-- ราคาบังคับตลอด ไม่ผูกกับ "จ่ายแล้ว" (เจ้าของเคาะ 2026-08-10) — ให้เหมือนหน้าจอง Private
             และหน้าจองรายครั้งที่บังคับตลอดอยู่แล้ว ทั้งสามหน้าจึงใช้กฎเดียวกัน: ต้องรู้ราคาเสมอ
             ติ๊ก "จ่ายแล้ว" เพิ่มอีก 3 อย่างที่ต้องรู้: วันที่จ่าย · วิธีจ่าย · ค่าธรรมเนียม -->
        <button class="id-btn id-btn-primary"
          :disabled="!editedItem.course
            || !hasPrice
            || (editedItem.paid == 1 && (!hasPayDate || !editedItem.paymentmethod || !hasPaymentFee))" @click="save">
          <span class="mdi mdi-content-save"></span> {{ $t('btn.save') }}</button>
      </template>
    </id-modal>

    <!-- ยืนยันก่อนปลดล็อกช่องค่าธรรมเนียม — ค่าที่ระบบคำนวณให้ถูกต้องเกือบทุกครั้ง
         การแก้เองจึงควรเป็นการตัดสินใจที่ตั้งใจ ไม่ใช่พิมพ์ทับไปโดยไม่รู้ตัว -->
    <id-modal v-model="showFeeEditConfirm" size="sm" icon="mdi-pencil-outline" :title="$t('customerCourse.paymentFeeConfirmTitle')">
      <p style="margin:0">{{ $t('customerCourse.paymentFeeConfirmBody', { amount: formatMoney(computedPaymentFee) }) }}</p>
      <template #footer>
        <button class="id-btn id-btn-ghost" @click="showFeeEditConfirm = false">{{ $t('btn.cancel') }}</button>
        <button class="id-btn id-btn-primary" @click="confirmFeeEdit">
          <span class="mdi mdi-pencil"></span> {{ $t('customerCourse.paymentFeeConfirmOk') }}</button>
      </template>
    </id-modal>

    <!-- ราคากลาง (rate card) — แค่ prefill ตอนสร้างแพ็กเกจใหม่ ไม่กระทบแพ็กเกจที่ขายไปแล้ว (price เป็น snapshot) -->
    <id-modal v-model="showPriceCatalog" size="lg" icon="mdi-cash-edit" :title="$t('customerCourse.priceCatalog')" :subtitle="$t('customerCourse.priceCatalogSub')">
      <div class="modal-sec"><span class="mdi mdi-book-open-variant"></span> {{ $t('customerCourse.groupPricing') }}</div>
      <div class="form-grid-4" style="align-items:end">
        <div class="field"><label>{{ $t('table.courseName') }}</label>
          <id-select v-model="newPriceRow.courseid" searchable :placeholder="$t('common.selectCourse')"
            :options="courseLookup.map(c => ({ value: c.courseid, label: c.coursename }))"></id-select></div>
        <div class="field"><label>{{ $t('table.courseType') }}</label>
          <id-select v-model="newPriceRow.coursetype" :placeholder="$t('common.select')" :options="['Monthly', 'Limited']"></id-select></div>
        <div class="field"><label>{{ newPriceRow.coursetype === 'Monthly' ? $t('customerCourse.period') : $t('customerCourse.quantitySessions') }}</label>
          <input class="id-input" type="number" min="1" v-model="newPriceRow.quantity" placeholder="0"></div>
        <div class="field"><label>{{ $t('table.price') }}</label>
          <div style="display:flex;gap:6px">
            <id-money v-model="newPriceRow.price" placeholder="0.00"></id-money>
            <button class="id-btn id-btn-primary id-btn-sm" :disabled="!newPriceRow.courseid || !newPriceRow.coursetype || !newPriceRow.quantity || !newPriceRow.price" @click="addCoursePriceRow">
              <span class="mdi mdi-plus"></span></button>
          </div>
        </div>
      </div>
      <div class="id-modal-grid" style="margin-top:10px"><div class="id-modal-grid-scroll" style="max-height:26vh">
        <table class="idt">
          <thead>
            <tr>
              <th>{{ $t('table.courseName') }}</th>
              <th style="text-align:center">{{ $t('table.courseType') }}</th>
              <th style="text-align:center">{{ $t('customerCourse.quantityOrPeriod') }}</th>
              <th style="text-align:center">{{ $t('table.price') }}</th>
              <th class="idt-action"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in coursePrices" :key="row.priceid">
              <td>{{ row.coursename }}</td>
              <td style="text-align:center">{{ row.coursetype }}</td>
              <td style="text-align:center">{{ row.quantity ?? '-' }}</td>
              <td style="text-align:center">{{ $money(row.price) }}</td>
              <td class="idt-action">
                <span class="mdi mdi-delete-forever" style="color:var(--c-error);cursor:pointer;font-size:18px" @click="deleteCoursePriceRow(row)"></span>
              </td>
            </tr>
            <tr v-if="!coursePrices.length">
              <td colspan="5" style="text-align:center;color:var(--c-text-muted)">{{ $t('customerCourse.noPriceSet') }}</td>
            </tr>
          </tbody>
        </table>
      </div></div>

      <div class="modal-sec mt"><span class="mdi mdi-account-heart-outline"></span> {{ $t('customerCourse.privatePricing') }}</div>
      <table class="idt" style="margin-top:8px">
        <thead>
          <tr>
            <th>{{ $t('customerCourse.privateType') }}</th>
            <th style="text-align:center">{{ $t('customerCourse.pricePerHour') }}</th>
            <th class="idt-action"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in privatePriceRows" :key="row.privatetype">
            <td>{{ { '1on1': $t('customerCourse.private1on1'), '2on1': $t('customerCourse.private2on1'), '3on1': $t('customerCourse.private3on1') }[row.privatetype] }}</td>
            <td style="text-align:center">
              <id-money v-model="row.price_per_hour" :placeholder="$t('customerCourse.noPriceSet')" style="max-width:120px"></id-money>
            </td>
            <td class="idt-action">
              <span class="mdi mdi-content-save" style="color:var(--c-success);cursor:pointer;font-size:18px" @click="savePrivatePriceRow(row)"></span>
            </td>
          </tr>
        </tbody>
      </table>
      <template #footer>
        <button class="id-btn id-btn-ghost" @click="showPriceCatalog = false">{{ $t('btn.close') }}</button>
      </template>
    </id-modal>

    <id-modal v-model="dialogDelete" size="sm" icon="mdi-delete-alert-outline" :title="$t('common.confirmDeleteTitle')" persistent>
      <p style="margin:0">{{ $t('courses.confirmDelete') }}</p>
      <template #footer>
        <button class="id-btn id-btn-ghost" @click="closeDelete">{{ $t('btn.cancel') }}</button>
        <button class="id-btn id-btn-primary" style="background:var(--c-error)" @click="checkBeforeDelete"><span class="mdi mdi-delete"></span> {{ $t('btn.confirm') }}</button>
      </template>
    </id-modal>
    <id-modal v-model="dialogFinish" size="sm" icon="mdi-check-decagram-outline" :title="$t('btn.finish')" persistent>
      <p style="margin:0">{{ $t('btn.finish') }}?</p>
      <template #footer>
        <button class="id-btn id-btn-ghost" @click="closeFinish">{{ $t('btn.cancel') }}</button>
        <button class="id-btn id-btn-primary" @click="finishCourseConfirm"><span class="mdi mdi-check"></span> {{ $t('btn.confirm') }}</button>
      </template>
    </id-modal>
    <id-modal v-model="dialogDeleteNotify" size="sm" icon="mdi-alert-outline" :title="$t('common.confirmDeleteTitle')" persistent>
      <p style="margin:0">{{ deleteNotifyMsg }}</p>
      <template #footer>
        <button class="id-btn id-btn-ghost" @click="closeDeleteNotify">{{ $t('btn.cancel') }}</button>
        <button class="id-btn id-btn-primary" style="background:var(--c-error)" @click="deleteItemConfirm"><span class="mdi mdi-delete"></span> {{ $t('btn.confirm') }}</button>
      </template>
    </id-modal>

    <!-- ปุ่มประวัติ (เดิมสเปกคือ "ลูกตา" — เจ้าของเปลี่ยนเป็น icon ประวัติ 17 ส.ค.) — audit + ไทม์ไลน์
         การแก้ไขจาก taction_log · โครงเดียวกับ dialog ข้อมูลการจองของหน้าจองคลาส/จอง Private -->
    <id-modal v-model="dialogCourseInfo" size="sm" icon="mdi-history"
      :title="$t('editHistory.title')" :subtitle="courseInfoItem.courserefer || ''">
      <div class="info-rows">
        <div class="info-row">
          <span class="info-label"><span class="mdi mdi-account-plus-outline"></span> {{ $t('table.createBy') }}</span>
          <span class="info-val">{{ courseInfoItem.createby || '-' }} <template v-if="courseInfoItem.createdate">· {{ format_datetime(courseInfoItem.createdate) }}</template></span>
        </div>
        <div v-if="courseInfoItem.updateby" class="info-row">
          <span class="info-label"><span class="mdi mdi-account-edit-outline"></span> {{ $t('table.updateBy') }}</span>
          <span class="info-val">{{ courseInfoItem.updateby }} <template v-if="courseInfoItem.editdate">· {{ format_datetime(courseInfoItem.editdate) }}</template></span>
        </div>
      </div>
      <edit-history-timeline v-if="dialogCourseInfo" kind="customercourse" :refid="courseInfoItem.courserefer"
        :preloaded="courseInfoHistory"></edit-history-timeline>
      <course-usage-timeline v-if="dialogCourseInfo" :refid="courseInfoItem.courserefer"
        :preloaded="courseInfoUsage"></course-usage-timeline>
      <template #footer>
        <button class="id-btn id-btn-primary" @click="dialogCourseInfo = false">{{ $t('btn.close') }}</button>
      </template>
    </id-modal>

    <!-- ขอเลื่อนวันหมดอายุหลายใบ + รายการ/อนุมัติ (COURSE_EXPIRY_ADJUST_DESIGN.md) -->
    <expiry-request-dialog v-model="expiryDialog" :is-head="isHead" :editing="expiryEdit" @done="onExpiryDone"
      @onLoading="v => $emit('onLoading', v)" @onErrorHandler="m => $emit('onErrorHandler', m)"></expiry-request-dialog>
    <expiry-request-list v-model="expiryList" :is-head="isHead" @changed="onExpiryChanged" @edit="onExpiryEdit"
      @onLoading="v => $emit('onLoading', v)" @onErrorHandler="m => $emit('onErrorHandler', m)"
      @onInfoHandler="m => $emit('onInfoHandler', m)"></expiry-request-list>
  </div>
</template>
<script>
import axios from "axios"
import presence from "@/utils/presence";
import { deleteQueuedSlips, fetchSlipImages } from "@/utils/slips";
import { fetchEditHistory, fetchCourseUsage } from "@/utils/history";
import { mapGetters } from "vuex";
import moment from "moment";
import { t } from "@/i18n";
import { formatDateTimeBKK } from "../../utils/datetime";
import { formatMoney } from "../../utils/money";
export default {
  data: () => ({
    search: "",
    dialog: false,
    dialogFinish: false,
    dialogDelete: false,
    loadingCustomerCourse: false,
    deleteNotifyMsg: "",
    dialogDeleteNotify: false,
    dialogCourseInfo: false,
    courseInfoItem: {},
    viewers: [],       // สตาฟคนอื่นที่เปิดจอนี้อยู่
    editors: {},       // courserefer -> username ที่เปิด dialog แก้ใบนั้นอยู่
    offPresence: null,
    presenceToken: 0,
    // สถานะ activate ของแถว ณ ตอนเปิด dialog แก้ไข (snapshot — ดู scheduleLocked)
    scheduleWasActivated: false,
    // เหตุผลที่เปลี่ยนวันหมดอายุ — ส่งไปต่อท้ายการ์ดแจ้งผู้ปกครอง (ไม่บังคับ) · originalExpiry = วันที่ตอนเปิด dialog
    expiryReason: '',
    originalExpiry: null,
    expiryDialog: false,
    expiryEdit: null,
    expiryList: false,
    pendingExpiry: 0,
    editedIndex: -1,
    editedItem: {
      courserefer: null,
      course: null,
      coursename: null,
      coursetype: null,
      remaining: null,
      startdate: null,
      expiredate: null,
      period: null,
      enable_double_booking: 0,
      paid: 0,
      paydate: null,
      shortnote: null,
      slip_image_url: '',
      price: null,
      paymentmethod: '',
      is_promotion: 0,
      payment_fee: '0.00',
    },
    defaultItem: {
      courserefer: null,
      course: null,
      coursename: null,
      coursetype: null,
      remaining: null,
      startdate: null,
      expiredate: null,
      period: null,
      enable_double_booking: 0,
      paid: 0,
      paydate: null,
      shortnote: null,
      slip_image_url: '',
      price: null,
      paymentmethod: '',
      is_promotion: 0,
      payment_fee: '0.00',
    },
    coursePrices: [], // ราคากลาง: [{priceid, courseid, coursetype, quantity, price, coursename}] — ใช้ prefill ตอนสร้างแพ็กเกจใหม่เท่านั้น
    privatePrices: [], // ราคากลาง Private: [{priceid, privatetype, price_per_hour}]
    // อัตราค่าธรรมเนียมบัตรเครดิต — ค่าจริงมาจาก backend (/getCoursePrices → creditCardFeeRate)
    // ซึ่งเป็น single source of truth ตัวเลข 0.03 ตรงนี้เป็นแค่ค่าสำรองกันหน้าพังตอนดึงไม่ได้
    creditCardFeeRate: 0.03,
    feeManualOverride: false,  // แอดมินยืนยันขอแก้ค่าธรรมเนียมเองแล้ว → หยุดคำนวณทับ
    showFeeEditConfirm: false, // dialog ยืนยันก่อนปลดล็อกช่องค่าธรรมเนียม
    showPriceCatalog: false,
    newPriceRow: { courseid: null, coursetype: null, quantity: null, price: null }, // ฟอร์มเพิ่มราคาใหม่ในหน้าจัดการราคากลาง
    privatePriceRows: [], // working copy 3 แถวคงที่ (1on1/2on1/3on1) สำหรับ dialog จัดการราคากลาง
    showPreview: false,
    isViewMode: false, // เปลี่ยนเป็น false เมื่ออยู่ในโหมดแก้ไข
    // multi-slip: ไฟล์สลิปที่รอแนบตอนกดบันทึก (เฉพาะใบใหม่ที่ยังไม่มี courserefer)
    // ใบเดิมไม่ใช้ตัวนี้ — SlipListPanel ยิง /addSlipImage เองทันที
    pendingSlips: [],
    // slipid ที่กดลบไว้ในพาเนล — ลบจริงตอนกดบันทึกเท่านั้น (ยกเลิก dialog = ไม่มีอะไรถูกลบ)
    pendingSlipDeletes: [],
    slipPreload: null,   // รายการสลิปที่โหลดไว้ก่อนเปิด dialog (ส่งให้พาเนลผ่าน :preloaded)
    courseInfoHistory: null,  // ไทม์ไลน์การแก้ไขที่โหลดไว้ก่อนเปิด dialog ประวัติ
    courseInfoUsage: null,    // ไทม์ไลน์การใช้คอร์ส (จอง/ย้าย/ยกเลิก/เช็คชื่อ) โหลดคู่กัน
    CourseUsingHeadersData: [],
    CourseUsingtList: [],
    // ใครถือแพ็กเกจนี้อยู่ / เคยใช้ — จาก /getStudentCourseDetail (ดู CourseHoldersLine.vue)
    courseHolders: null,
    courseEverUsed: null,
    courselist: [],
    notNullRules: [
      v => !!v || t('common.required'),
    ],
    totalItems: 0,
    tableOptions: { page: 1, itemsPerPage: 10, sortBy: [] },
    filterCoursetype: '',   // server filter — /getCustomerCourseList filters on `coursetype`
    filterPaid: '',         // server filter — /getCustomerCourseList filters on `paid` (1/0)
    filterPromotion: '',    // server filter — /getCustomerCourseList filters on `is_promotion` (1/0)
    searchTimer: null,
    isMounted: false,
  }),

  computed: {
    // วันหมดอายุถูกเปลี่ยนจากวันหนึ่งเป็นอีกวัน (ไม่นับตั้งครั้งแรก) → backend จะส่งการ์ดถึงผู้ปกครอง จึงถามเหตุผล
    expiryChanged() {
      if (this.editedIndex === -1 || !this.originalExpiry || !this.editedItem.expiredate) return false;
      return this.SQLDate(this.editedItem.expiredate) !== this.originalExpiry;
    },
    // คนอื่นที่เปิด dialog แก้ใบเดียวกันนี้อยู่ (ไม่นับตัวเอง — ฝั่งเซิร์ฟเวอร์ตัดตัวเองออกให้แล้ว)
    // **ด่านที่สอง ห้ามโชว์ชื่อตัวเอง** — ฝั่งเซิร์ฟเวอร์กรองให้แล้ว แต่อย่าพึ่งสัญญาฝั่งเดียว
    // ป้ายที่ลั่นทุกครั้งที่เปิด dialog ผู้ใช้จะเรียนรู้ที่จะไม่อ่านมันภายในวันเดียว = ฟีเจอร์ตายทั้งฟีเจอร์
    myUsername() {
      const u = this.$store.getters.getUserdata;
      return (u && u.username) || '';
    },
    otherEditor() {
      if (!this.dialog || !this.editedItem.courserefer) return null;
      const who = this.editors[this.editedItem.courserefer];
      return who && who !== this.myUsername ? who : null;
    },
    ...mapGetters({
      token: "getToken",
    }),
    // "กรอกราคาแล้วหรือยัง" — เช็คว่าว่างหรือไม่ ห้ามใช้ความจริง/เท็จของค่า เพราะราคา 0 บาท
    // (แถมฟรี/ชดเชย) เป็นค่าที่ตั้งใจกรอกได้จริง ถ้าใช้ !price จะบล็อกเคสนั้นไปด้วย
    // หลัง blur ค่าจะเป็นสตริง '0.00' ซึ่ง !'0.00' เป็น false อยู่แล้ว แต่ก่อน blur เป็น 0 ตัวเลข
    hasPrice() {
      const v = this.editedItem.price;
      if (v === null || v === undefined || String(v).trim() === '') return false;
      // ราคาติดลบไม่ใช่ราคา — min="0" กันแค่ปุ่ม spinner แต่พิมพ์ -500 เองได้ (audit E1;
      // backend ปฏิเสธด้วยเช่นกัน ตรงนี้กันปุ่มบันทึกไม่ให้พาไปชนกำแพง)
      const n = Number(v);
      return Number.isFinite(n) && n >= 0;
    },
    // ติ๊ก "จ่ายแล้ว" = ต้องรู้ครบว่า จ่ายเท่าไหร่ / เมื่อไหร่ / ด้วยวิธีไหน / มีค่าธรรมเนียมเท่าไหร่
    // ทั้ง 4 อย่างเป็นข้อมูลที่รายงานการเงินใช้จริง ขาดอันใดอันหนึ่งยอดจะเพี้ยนหรือระบุที่มาไม่ได้
    // ค่าธรรมเนียมปกติระบบเติมให้เอง จะว่างได้ก็ต่อเมื่อแอดมินกดปลดล็อกแล้วลบทิ้ง — ต้องกันไว้
    // (เช็คว่า "ว่างหรือไม่" ไม่ใช่ความจริง/เท็จ เพราะ 0.00 เป็นค่าที่ถูกต้องและพบบ่อยที่สุด)
    hasPayDate() {
      const v = this.editedItem.paydate;
      return v !== null && v !== undefined && String(v).trim() !== '';
    },
    hasPaymentFee() {
      const v = this.editedItem.payment_fee;
      return v !== null && v !== undefined && String(v).trim() !== '';
    },
    // ═══ กติกาสิทธิ์แก้ "กำหนดการ" ของใบ (เจ้าของเคาะ 17 ส.ค.) ═══
    // ระยะเวลา/วันเริ่ม/วันหมดอายุ: head แก้ได้ตลอด · แอดมินแก้ได้เฉพาะใบที่ยังไม่ถูกจองครั้งแรก
    // หรือยังไม่ activate (ยังไม่มีทั้งวันเริ่มและวันหมดอายุ) — backend บังคับซ้ำที่ /updateCustomerCourse
    isHead() {
      const u = this.$store.getters.getUserdata;
      return String(u && u.usertype) === '0';
    },
    scheduleLocked() {
      if (this.isHead) return false;
      if (this.editedIndex === -1) return false;          // สร้างใหม่ — ยังไม่มีอะไรให้ล็อก
      // ตารางการใช้งานโหลด async ตอนเปิด dialog — ระหว่างโหลดถือว่า "จองแล้ว" ไว้ก่อน
      // (ล็อกเกินชั่วครู่ปลอดภัยกว่าเปิดช่องแวบหนึ่งแล้วค่อยล็อก)
      const booked = this.loadingCourse || (this.CourseUsingtList || []).length > 0;
      // "activate แล้วหรือยัง" ต้องดูจากค่าที่บันทึกไว้ตอนเปิด dialog (scheduleWasActivated —
      // เซ็ตใน editItem) ไม่ใช่ editedItem ที่กำลังแก้ — ผลรีวิว: ถ้าอ่านค่าสด แอดมินที่เพิ่งเลือก
      // วันเริ่มบนใบที่ยัง deactivated จะโดนล็อกกลางมือทันที ยังไม่ทันได้เลือกวันหมดอายุ
      return booked && this.scheduleWasActivated;
    },
    headers() {
      return [
        { title: this.$t('table.courseRef'), align: "start", key: "courserefer" },
        { title: this.$t('table.courseName'), key: "coursename" },
        { title: this.$t('table.courseType'), key: "coursetype" },
        { title: this.$t('table.startDate'), key: "startdate", align: "center" },
        { title: this.$t('table.expireDate'), key: "expiredate", align: "left" },
        { title: this.$t('table.remaining'), key: "remaining", align: "end" },
        { title: this.$t('table.courseUser'), key: "userlist", align: "left", sortable: false },
        { title: this.$t('table.payment'), key: "paid", align: "center", sortable: false },
        { title: this.$t('table.view'), key: "view", sortable: false, align: "center" },
        { title: this.$t('table.edit'), key: "edit", sortable: false, align: "center" },
        { title: this.$t('table.delete'), key: "delete", sortable: false, align: "center" },
        { title: this.$t('table.finish'), key: "finish", sortable: false, align: "center" },
      ];
    },
    // payment-method options for the create/edit dialog (labels localize via $t)
    paymentOptions() {
      return [
        { value: 'cash', label: this.$t('customerCourse.paymentCash') },
        { value: 'transfer', label: this.$t('customerCourse.paymentTransfer') },
        { value: 'credit', label: this.$t('customerCourse.paymentCredit') },
      ];
    },
    // ค่าธรรมเนียมที่ "ควรเป็น" ตามราคา+วิธีจ่ายปัจจุบัน — ต้องให้ผลตรงกับ computePaymentFee()
    // ฝั่ง server (server.js) เป๊ะ ๆ ทั้งสูตรและการปัดเศษ ไม่งั้นค่าที่แอดมินเห็นกับที่บันทึกจะไม่ตรงกัน
    computedPaymentFee() {
      if (this.editedItem.paymentmethod !== 'credit') return 0;
      const price = Number(this.editedItem.price);
      if (!Number.isFinite(price) || price <= 0) return 0;
      return Math.round(price * this.creditCardFeeRate * 100) / 100;
    },
    // 0.03 → "3" (ตัดศูนย์ท้ายทิ้ง เช่น 0.0325 → "3.25")
    feeRatePercentLabel() {
      return String(Number((this.creditCardFeeRate * 100).toFixed(4)));
    },
    formTitle() {
      return this.editedIndex === -1 ? this.$t('courses.newCourse') : this.$t('courses.editCourse')
    },
    CourseUsingHeaders() {
      return [
        { title: '#', key: 'index', width: '50px', sortable: false },
        { title: this.$t('table.name'), key: 'fullname' },
        { title: this.$t('table.date'), key: 'classdate' },
        { title: this.$t('table.time'), key: 'classtime' },
        { title: this.$t('courseUsage.bookedBy'), key: 'createby' },
        { title: this.$t('bookingMgmt.updateBy'), key: 'lastedit_by' },
      ]
    },
  },

  watch: {
    search() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.tableOptions.page = 1;
        this.getCustomerCourseList();
      }, 500);
    },
    dialog(val) {
      val || this.close();
    },
    dialogFinish(val) {
      val || this.closeFinish();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogDeleteNotify(val) {
      val || this.closeDeleteNotify();
    },
  },

  async created() {
    try {
      const token = this.$store.getters.getToken;
      //console.log("token ", token);
      if (!token) {
        this.errorMsg = "Not found token, Please login...";
        this.errorDialog = true;
        this.$emit("onClickChangeState", "login");
        return;
      }

      await axios
        .post(
          this.baseURL + "/verifyToken",
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          //console.dir(response);
          if (response.data.success) {
            this.initialize();
          }
        })
        .catch((error) => {
          //console.error(error);
          this.$emit("onErrorHandler", error.response.data.message);
          this.$emit("onClickChangeState", "login");
        });
    } catch (error) {
      this.$emit("onErrorHandler", error.message);
    }
  },

  mounted() {
    this.isMounted = true;
    // ป้าย "ใครเปิดจอนี้อยู่" + "ใบไหนมีคนแก้อยู่" — เตือนอย่างเดียว ไม่บล็อกปุ่มบันทึก
    this.presenceToken = presence.enter('customercourse');
    this.offPresence = presence.subscribe((p) => { this.viewers = p.viewers; this.editors = p.editors; });
    this.loadPendingExpiry();
  },
  beforeUnmount() {
    presence.leave(this.presenceToken);
    if (this.offPresence) this.offPresence();
  },

  methods: {
    // ป้ายจำนวนคำขอเลื่อนวันหมดอายุที่รอผู้จัดการ (เฉพาะผู้จัดการ) — เงียบ ๆ ไม่ขึ้น error
    async loadPendingExpiry() {
      if (!this.isHead) return;
      try {
        const res = await axios.post(this.baseURL + '/getExpiryRequests', { status: 'pending' },
          { headers: { Authorization: 'Bearer ' + this.$store.getters.getToken } });
        this.pendingExpiry = res.data.success ? res.data.requests.length : 0;
      } catch (e) { /* ป้ายเฉย ๆ */ }
    },
    // ปุ่ม "แก้ไขคำขอ" ในรายการ → ปิดรายการ แล้วเปิด dialog ยื่นคำขอในโหมดแก้ไข
    onExpiryEdit(detail) {
      this.expiryList = false;
      this.expiryEdit = detail;
      this.expiryDialog = true;
    },
    async onExpiryDone(r) {
      const badSlips = (r.slipChecks || []).filter((x) => x.status !== 'verified').length;
      if (badSlips > 0) this.$emit('onErrorHandler', this.$t('expiryReq.slipCheckWarn', { n: badSlips })); // ยื่นสำเร็จแล้ว แต่สลิปบางใบไม่ผ่าน/ตรวจไม่ได้ — บอกคนยื่นทันที
      if (r.updated) { this.$emit('onInfoHandler', this.$t('expiryReq.updatedMsg')); await this.onExpiryChanged(); return; }
      const failed = r.applied ? (r.results || []).filter((x) => x.status !== 'approved').length : 0;
      if (failed > 0) this.$emit('onErrorHandler', this.$t('expiryReq.decidedWithFail', { n: failed })); // อย่ารายงานสำเร็จเมื่อมีใบที่เลื่อนไม่ได้
      else this.$emit('onInfoHandler', r.applied ? this.$t('expiryReq.appliedMsg') : this.$t('expiryReq.pendingMsg'));
      await this.onExpiryChanged();
    },
    async onExpiryChanged() {
      await this.getCustomerCourseList();
      await this.loadPendingExpiry();
    },
    async initialize() {
      this.tableOptions.page = 1;
      this.$emit("onLoading", true);
      await this.getCustomerCourseList();
      await this.getCourseLookup();
      await this.getCoursePrices();
      await this.getPrivatePrices();
      this.$emit("onLoading", false);
    },
    async getCoursePrices() {
      const token = this.$store.getters.getToken;
      try {
        const response = await axios.get(this.baseURL + "/getCoursePrices", {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.data.success) {
          this.coursePrices = response.data.results || [];
          // อัตราค่าธรรมเนียมบัตรเครดิตมาจาก backend (single source of truth) — เดินทางมากับ rate card
          // เพราะเป็นค่าตั้งราคาเหมือนกันและหน้านี้เรียก endpoint นี้อยู่แล้ว
          if (Number.isFinite(Number(response.data.creditCardFeeRate))) {
            this.creditCardFeeRate = Number(response.data.creditCardFeeRate);
          }
        }
      } catch (error) {
        // ราคากลางเป็นแค่ตัวช่วย prefill — ดึงไม่ได้ก็ยังกรอกราคาเองตอนสร้างแพ็กเกจได้ปกติ ไม่ต้องโชว์ error dialog
      }
    },
    // ── ค่าธรรมเนียมการชำระเงิน ────────────────────────────────────────────────
    // จำนวนเงิน 2 ตำแหน่งเสมอ — สูตรกลางอยู่ที่ utils/money.js (ห้ามเขียนสูตรซ้ำที่นี่)
    formatMoney,
    applyAutoFee() {
      // เก็บเป็นสตริง 2 ตำแหน่งเสมอ ให้ตรงกับช่องราคาที่โชว์ค่าดิบจาก DB ('6900.00')
      // Number() เฉย ๆ จะทำให้ 207.00 กลายเป็น 207 บนหน้าจอ (ทศนิยมหาย)
      this.editedItem.payment_fee = this.computedPaymentFee.toFixed(2);
    },
    // แก้ราคา → ค่าธรรมเนียมตามไปด้วย เว้นแต่แอดมินขอแก้เอง (เคารพค่าที่เขาตั้งใจใส่)
    onPriceChanged() {
      if (!this.feeManualOverride) this.applyAutoFee();
    },
    // เปลี่ยนวิธีจ่าย = เปลี่ยนฐานของค่าธรรมเนียมทั้งก้อน → ล้าง override เสมอ
    // (ค่าธรรมเนียมบัตรที่แอดมินแก้เองไว้ ไม่มีความหมายอีกต่อไปเมื่อสลับไปเงินสด/โอน)
    onPaymentMethodChanged() {
      this.feeManualOverride = false;
      this.applyAutoFee();
    },
    confirmFeeEdit() {
      this.feeManualOverride = true;
      this.showFeeEditConfirm = false;
    },
    resetFeeToAuto() {
      this.feeManualOverride = false;
      this.applyAutoFee();
    },
    async getPrivatePrices() {
      const token = this.$store.getters.getToken;
      try {
        const response = await axios.get(this.baseURL + "/getPrivatePrices", {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.data.success) this.privatePrices = response.data.results || [];
      } catch (error) {
        // เช่นเดียวกับราคากลางคอร์สกลุ่ม — ดึงไม่ได้ก็ยังกรอกราคาเองได้ปกติ
      }
      // เติมแถวคงที่ 3 แถวเสมอ (1on1/2on1/3on1) ผสานราคาที่เคยตั้งไว้ (ถ้ามี)
      this.privatePriceRows = ["1on1", "2on1", "3on1"].map((pt) => {
        const found = this.privatePrices.find((p) => p.privatetype === pt);
        return { privatetype: pt, price_per_hour: found ? found.price_per_hour : null };
      });
    },
    onSelectCourse(id) {
      this.editedItem.course = this.courseLookup.find((c) => c.courseid === id);
      this.maybeAutofillPrice();
    },
    // เปลี่ยนประเภทคอร์ส: Monthly = ไม่จำกัดครั้ง (total NULL) → ล้าง "คงเหลือ" ทิ้ง
    // ไม่ให้เหลือค่าค้างในช่องที่ถูก disable หรือถูกส่งไปตอนบันทึก แล้วค่อยเติมราคาอัตโนมัติ
    onCourseTypeChange() {
      if (this.editedItem.coursetype === 'Monthly') this.editedItem.remaining = null;
      this.maybeAutofillPrice();
    },
    // เติมราคาอัตโนมัติจากราคากลางตอน "สร้างแพ็กเกจใหม่" เท่านั้น — ตอนแก้ไขแพ็กเกจเดิม ราคาคือ snapshot
    // ที่บันทึกไว้ตั้งแต่ตอนขาย ห้ามให้ราคากลางเขียนทับ
    maybeAutofillPrice() {
      if (this.editedIndex > -1) return;
      if (!this.editedItem.course || !this.editedItem.coursetype) return;
      const qty = this.editedItem.coursetype === "Monthly" ? this.editedItem.period : this.editedItem.remaining;
      const found = this.coursePrices.find(
        (p) => p.courseid === this.editedItem.course.courseid
          && p.coursetype === this.editedItem.coursetype
          && String(p.quantity) === String(qty)
      );
      if (found) {
        this.editedItem.price = found.price;
        // ราคาถูกเซ็ตด้วยโค้ด ไม่ใช่การพิมพ์ → event @input ไม่ยิง ต้องอัปเดตค่าธรรมเนียมเอง
        if (!this.feeManualOverride) this.applyAutoFee();
      }
    },
    openPriceCatalog() {
      this.newPriceRow = { courseid: null, coursetype: null, quantity: null, price: null };
      this.showPriceCatalog = true;
    },
    async addCoursePriceRow() {
      const token = this.$store.getters.getToken;
      try {
        const response = await axios.post(
          this.baseURL + "/saveCoursePrice",
          { courseid: this.newPriceRow.courseid, coursetype: this.newPriceRow.coursetype, quantity: this.newPriceRow.quantity, price: this.newPriceRow.price },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (response.data.success) {
          this.$emit("onInfoHandler", this.$t("customerCourse.priceSaved"));
          this.newPriceRow = { courseid: null, coursetype: null, quantity: null, price: null };
          await this.getCoursePrices();
        } else {
          this.$emit("onErrorHandler", response.data.message);
        }
      } catch (error) {
        this.$emit("onErrorHandler", error.response ? error.response.data.message : error.message);
      }
    },
    async deleteCoursePriceRow(row) {
      const token = this.$store.getters.getToken;
      try {
        const response = await axios.post(
          this.baseURL + "/deleteCoursePrice",
          { priceid: row.priceid },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (response.data.success) {
          this.$emit("onInfoHandler", this.$t("customerCourse.priceSaved"));
          await this.getCoursePrices();
        } else {
          this.$emit("onErrorHandler", response.data.message);
        }
      } catch (error) {
        this.$emit("onErrorHandler", error.response ? error.response.data.message : error.message);
      }
    },
    async savePrivatePriceRow(row) {
      if (row.price_per_hour === null || row.price_per_hour === "" || row.price_per_hour === undefined) return;
      const token = this.$store.getters.getToken;
      try {
        const response = await axios.post(
          this.baseURL + "/savePrivatePrice",
          { privatetype: row.privatetype, price_per_hour: row.price_per_hour },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (response.data.success) {
          this.$emit("onInfoHandler", this.$t("customerCourse.priceSaved"));
          await this.getPrivatePrices();
        } else {
          this.$emit("onErrorHandler", response.data.message);
        }
      } catch (error) {
        this.$emit("onErrorHandler", error.response ? error.response.data.message : error.message);
      }
    },
    // ลบสลิปที่มาร์กไว้จริง ๆ · ใบที่ลบไม่สำเร็จ **ค้างไว้ในคิวเหมือนเดิม** เพื่อให้ผู้ใช้เห็นว่ายังไม่หาย
    // และกดบันทึกซ้ำได้ (เดิมล้างคิวทิ้งทุกกรณี แถมขึ้นข้อความแดงตามด้วยเขียว "บันทึกสำเร็จ")
    async flushSlipDeletes(token) {
      if (this.pendingSlipDeletes.length === 0) return;
      const delResult = await deleteQueuedSlips(this.baseURL, token, this.pendingSlipDeletes);
      this.pendingSlipDeletes = delResult.failed;
      if (delResult.failed.length > 0) this.$emit("onErrorHandler", this.$t('customerCourse.slipDeleteFail'));
    },
    // ปุ่มประวัติบนแถวตาราง — เปิด dialog audit + ไทม์ไลน์การแก้ไข (อ่านอย่างเดียว)
    // ดึงไทม์ไลน์ให้ครบก่อนเปิด dialog ไม่งั้นบล็อกประวัติจะโผล่ทีหลังเหมือนหน้าจอกระพริบ
    async showCourseInfo(item) {
      this.courseInfoItem = Object.assign({}, item);
      this.$emit("onLoading", true);
      try {
        const token = this.$store.getters.getToken;
        [this.courseInfoHistory, this.courseInfoUsage] = await Promise.all([
          fetchEditHistory(this.baseURL, token, "customercourse", item.courserefer),
          fetchCourseUsage(this.baseURL, token, item.courserefer),
        ]);
      } finally {
        this.$emit("onLoading", false);
      }
      this.dialogCourseInfo = true;
    },
    // ข้อความ "สร้างคอร์สแล้ว" + เลขที่คอร์สต่อท้าย
    // backend ตอบ message เป็นอังกฤษตายตัว ('Successfully Course No :GA-…') ซึ่งใช้ไม่ได้กับระบบ 5 ภาษา
    // จึงประกอบข้อความฝั่งนี้เอง — เลขที่คอร์สยังอยู่ครบเหมือนเดิม (สตาฟใช้อ่าน/บอกต่อ ส่วน clipboard
    // ก็ยังคัดลอกให้เงียบ ๆ เหมือนเดิม) · ใส่ในวงเล็บจึงอ่านรู้เรื่องทุกภาษาโดยไม่ต้องเพิ่มคีย์ i18n
    courseCreatedMsg(courserefer) {
      const base = this.$t('msg.courseCreated');
      return courserefer ? `${base} (${courserefer})` : base;
    },
    copyToClipboard(newcourse) {
      if (newcourse) {
        navigator.clipboard.writeText(newcourse)
          .then(() => {
            //consol.log('คัดลอกคอร์สใหม่เรียบร้อยแล้ว');
          })
          .catch(() => {
            //console.error('ไม่สามารถคัดลอกได้: ', err);
          });
      } else {
        //this.$emit("onErrorHandler", "ไม่มีคอร์สใหม่ที่จะคัดลอก");
      }
    },

    // กติกาเปิด dialog ทั้งระบบ (เจ้าของสั่ง 2026-08-21): เตรียมข้อมูลให้ครบ "ก่อน" เปิด
    // ไม่ใช่เปิดแล้วค่อยเติมทีละช่อง — ระหว่างเตรียมใช้ overlay โหลดของ App.vue คลุมไว้
    async editItem(item) {
      this.$emit("onLoading", true);
      try {
        await this.editItemPrepare(item);
      } finally {
        this.$emit("onLoading", false);
      }
      this.dialog = true;
      presence.edit(item.courserefer);   // บอกคนอื่นว่าใบนี้กำลังถูกแก้ · สายขาดเมื่อไหร่ล็อกหายเอง
    },
    async editItemPrepare(item) {
      await this.getCourseLookup();
      this.editedIndex = this.courselist.findIndex(course => course.courserefer === item.courserefer);
      this.editedItem = Object.assign({}, item);
      // snapshot สถานะ activate จากแถวจริงก่อนถูกแก้ — ใช้ตัดสิน scheduleLocked ตลอดอายุ dialog
      this.scheduleWasActivated = !!(item.startdate || item.expiredate);
      this.originalExpiry = item.expiredate ? this.SQLDate(new Date(item.expiredate)) : null;
      this.expiryReason = '';
      if(this.editedItem.startdate) this.editedItem.startdate = new Date(item.startdate);
      if(this.editedItem.expiredate) this.editedItem.expiredate = new Date(item.expiredate);
      // paydate ต้องแปลงเป็น Date เหมือนสองตัวบน — ปล่อย ISO string ดิบเข้า id-date จะโชว์วันที่ UTC (-1 วันเวลาไทย)
      if(this.editedItem.paydate) this.editedItem.paydate = new Date(item.paydate);
      
      let course = this.courseLookup.find(
        (course) => course.courseid == this.editedItem.courseid
      );
      this.editedItem.course = course;
      // ค่าธรรมเนียมของแถวเดิม:
      //   NULL/ว่าง = แถวก่อนมีฟีเจอร์นี้ ไม่เคยเก็บไว้ → ให้ระบบคำนวณให้ใหม่ (บันทึกครั้งถัดไปจะเติมให้เอง)
      //   มีค่าแต่ไม่ตรงกับที่คำนวณได้ = เคยแก้เองไว้ → ปลดล็อกช่องพร้อมป้ายเตือนตั้งแต่เปิด
      //   จะได้ไม่ถูกคำนวณทับตอนแอดมินไปแก้ราคา และมองออกทันทีว่าแถวนี้ค่าธรรมเนียมไม่ใช่ค่ามาตรฐาน
      const storedFee = item.payment_fee;
      if (storedFee === null || storedFee === undefined || storedFee === '') {
        this.feeManualOverride = false;
        this.applyAutoFee();
      } else {
        this.editedItem.payment_fee = Number(storedFee).toFixed(2);
        this.feeManualOverride = Number(storedFee) !== this.computedPaymentFee;
      }
      // ต้อง await — ตัวนี้เติม "ผู้ใช้คอร์ส" กับตารางประวัติการใช้ ถ้าปล่อยลอย ช่องพวกนั้น
      // จะโผล่ทีหลังตอน dialog เปิดอยู่แล้ว (อาการกระพริบที่เจ้าของแจ้ง)
      // ดึงคู่ขนานกับรายการสลิป — ค่าใช้จ่ายเวลาเปิด dialog = ตัวที่ช้าสุด ไม่ใช่ผลรวม
      const [, slipData] = await Promise.all([
        this.checkCourseUser(),
        fetchSlipImages(this.baseURL, this.$store.getters.getToken, 'course', item.courserefer),
      ]);
      this.slipPreload = slipData;
      if(this.editedItem.slip_image_url) {
        this.isViewMode = true;
      }
    },
    // ติ๊ก "จ่ายแล้ว/ยังไม่จ่าย" — พอกลับเป็นยังไม่จ่าย ล้างวิธีชำระ/วันที่/สลิปที่เลือกไว้ (ช่องถูกปิด)
    togglePaid() {
      this.editedItem.paid = this.editedItem.paid ? 0 : 1;
      if (!this.editedItem.paid) {
        this.editedItem.paymentmethod = '';
        this.editedItem.paydate = null;
        this.pendingSlips = [];
        this.pendingSlipDeletes = [];
        // วิธีชำระถูกล้าง → ค่าธรรมเนียมต้องกลับเป็น 0.00 ตามไปด้วย ไม่ใช่ค้างยอดบัตรเครดิตไว้
        this.onPaymentMethodChanged();
      }
    },
    finishCourse(item) {
      this.editedIndex = this.courselist.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogFinish = true;
    },
    deleteItem(item) {
      this.editedIndex = this.courselist.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    async checkBeforeDelete() {
      this.$emit("onLoading", true);
      const token = this.$store.getters.getToken;
      await axios
        .post(
          this.baseURL + "/checkBeforeDeleteCustomerCourse",
          {
            courserefer: this.editedItem.courserefer,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((response) => {
          //console.dir(response);
          if (response.data.success) {
            this.deleteItemConfirm();
          } else {
            let nicknameList = [];
            response.data.results.forEach((result) => {
              nicknameList.push(result.nickname);
            });
            //console.dir(nicknameList);
            this.deleteNotifyMsg =
              this.$t("customerCourse.deleteInUse", { names: nicknameList.join(", ") });
            this.dialogDeleteNotify = true;
            this.dialogDelete = false;
            this.$emit("onLoading", false);
          }
        })
        .catch(() => {
          //console.error(error);
          this.$emit("onLoading", false);
          return false;
        });
    },
    async finishCourseConfirm() {
      this.$emit("onLoading", true);
      const token = this.$store.getters.getToken;
      await axios
        .post(
          this.baseURL + "/finishCustomerCourse",
          {
            courserefer: this.editedItem.courserefer,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((response) => {
          //console.dir(response);
          if (response.data.success) {
            this.dialogFinish = false;
            this.$emit("onInfoHandler", this.$t('msg.courseDone'));
          } else {
            this.dialogFinish = false;
            this.$emit(
              "onErrorHandler",
              response.data.message || this.$t('msg.updateFail')
            );
          }
          this.initialize();
        })
        .catch(() => {
          //console.error(error);
        });
      this.$emit("onLoading", false);
    },
    async deleteItemConfirm() {
      this.$emit("onLoading", true);
      const token = this.$store.getters.getToken;
      await axios
        .post(
          this.baseURL + "/deleteCustomerCourse",
          {
            courserefer: this.editedItem.courserefer,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((response) => {
          //console.dir(response);
          if (response.data.success) {
            this.dialogDelete = false;
            this.dialogDeleteNotify = false;
            this.$emit("onInfoHandler", this.$t('msg.courseDeleted'));
          } else {
            this.dialogDelete = false;
            this.dialogDeleteNotify = false;
            this.$emit(
              "onErrorHandler",
              response.data.message || this.$t('msg.updateFail')
            );
          }
          this.initialize();
        })
        .catch(() => {
          //console.error(error);
        });
      this.$emit("onLoading", false);
    },
    async checkCourseUser() {
      this.loadingCourse = true;
      // ล้างของ dialog ก่อนหน้าเสมอ — ผลรีวิว: ถ้า fetch ล้ม/ตอบไม่สำเร็จ ค่าเดิมของใบก่อน
      // จะค้างอยู่ แล้ว scheduleLocked ของใบที่จองแล้วอ่านเป็น "ยังไม่จอง" (ช่องปลดล็อกผิด)
      this.CourseUsingtList = [];
      this.courseHolders = null;
      this.courseEverUsed = null;
      await axios
        .get(
          this.baseURL + "/getStudentCourseDetail/" + this.editedItem.courserefer,
          {
            headers: { Authorization: `Bearer ${this.token}` },
          }
        )
        .then((response) => {
          //console.dir(response);
          if (response.data.success) {
            //console.log("getStudentCourseDetail", response.data);
            // ตารางการใช้งานมาจาก tbooking_group จึงมีได้แม้ไม่มีแถวแพ็กเกจแล้ว — อ่านนอก if
            this.CourseUsingtList = response.data.courseDetail || [];
            // holders/everUsed มาจาก backend คนละบล็อกกับ results เดิม (ไม่ขึ้นกับ results.length)
            // แพ็กเกจที่ถูกลบไปแล้วยังมี everUsed อยู่ — แท็บ "คอร์สที่ถูกลบ" ต้องเห็นชื่อคนใช้
            this.courseHolders = response.data.holders || null;
            this.courseEverUsed = response.data.everUsed || null;
          } else {
            this.$emit("onErrorHandler", this.$t("customerCourse.loadFail"));
          }
        })
        .catch((error) => {
          //console.log(error);
          if (error.response && error.response.status == 401) {
            this.$emit("onErrorHandler", error.response.data.message);
            this.$emit("onClickChangeState", "login");
          } else {
            this.$emit("onErrorHandler", error.message);
          }
        });
      this.loadingCourse = false;
    },
    close() {
      presence.edit(null);
      this.dialog = false;
      this.courseHolders = null;      // ผู้ใช้ของใบก่อนห้ามไปโผล่ในใบถัดไป (เดิมค่านี้อยู่ใน
      this.courseEverUsed = null;     // editedItem จึงถูกล้างฟรีตอน Object.assign defaultItem)
      this.isViewMode = false;
      this.pendingSlips = [];        // ไฟล์ที่ค้างในคิวห้ามติดไปใบถัดไป
      this.pendingSlipDeletes = [];  // เครื่องหมายลบก็เช่นกัน — ยกเลิก dialog = ไม่ลบอะไรเลย
      this.slipPreload = null;       // ข้อมูลสลิปของใบก่อนห้ามไปโผล่ในใบถัดไป
      this.feeManualOverride = false; // ปลดล็อกค่าธรรมเนียมเป็นเรื่องเฉพาะแพ็กเกจที่กำลังแก้ ไม่ติดไปใบถัดไป
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeFinish() {
      this.dialogFinish = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      if (!this.dialogDeleteNotify) {
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      }
    },

    closeDeleteNotify() {
      this.dialogDeleteNotify = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    /*
    async save() {
      const { valid } = await this.$refs.courseform.validate()
      if(valid) {
        this.$emit("onLoading", true);
        const token = this.$store.getters.getToken;
        //console.log("save", this.editedItem);

        let startdate = null;
        let expiredate = null;
        let paydate = null;
        if (this.editedItem.startdate !==null && this.editedItem.startdate !=="") {
          startdate = this.SQLDate(this.editedItem.startdate);
        }
        if (this.editedItem.expiredate !==null && this.editedItem.expiredate !=="") {
          expiredate = this.SQLDate(this.editedItem.expiredate);
        }
        if (this.editedItem.paydate !==null && this.editedItem.paydate !=="") {
          paydate = this.SQLDate(this.editedItem.paydate);
        }
        if (this.editedItem.shortnote !== null && this.editedItem.shortnote !== "") {
          this.editedItem.shortnote = this.editedItem.shortnote;
        } else {
          this.editedItem.shortnote = "";
        }
        try {
          if (this.editedIndex > -1) {
            let saveObj = {
              courserefer: this.editedItem.courserefer,
              course: this.editedItem.course,
              courseid: this.editedItem.courseid,
              coursetype: this.editedItem.coursetype,
              course_shortname: this.editedItem.course_shortname,
              remaining: this.editedItem.remaining,
              startdate: startdate,
              expiredate: expiredate,
              period: this.editedItem.period,
              paid: this.editedItem.paid,
              paydate: paydate,
              shortnote: this.editedItem.shortnote,
              slip_customer: this.editedItem.slip_customer,
              slip_image_url: this.editedItem.slip_image_url
            };
            const response = await axios.post(this.baseURL + "/updateCustomerCourse", saveObj, {
              headers: { Authorization: `Bearer ${token}` },
            });
            if (response.data.success) {
              await this.handleUploadSlip(this.editedItem.slip_customer, this.editedItem.courserefer);
              // ห้ามใช้ response.data.message นำหน้า — backend ตอบอังกฤษตายตัว ('Customer Course updated
              // successfully') ซึ่งชนะ $t() เสมอ ทำให้ผู้ใช้ภาษาไทยเห็น dialog เป็นอังกฤษ (แจ้ง 17 ส.ค.)
              // ข้อความสำเร็จไม่มีข้อมูลอะไรที่ฝั่งนี้ไม่รู้อยู่แล้ว จึงแปลเองทั้งหมด เหมือน finish/delete
              this.$emit("onInfoHandler", this.$t('msg.courseUpdated'));
            } else {

              this.$emit("onErrorHandler", response.data.message || this.$t('msg.updateFail'));
            }
            this.initialize();
          } else {
            let saveObj = {
              courserefer: this.editedItem.courserefer,
              course: this.editedItem.course,
              coursetype: this.editedItem.coursetype,
              course_shortname: this.editedItem.course_shortname,
              remaining: this.editedItem.remaining,
              startdate: startdate,
              expiredate: expiredate,
              period: this.editedItem.period,
              paid: this.editedItem.paid,
              paydate: paydate,
              shortnote: this.editedItem.shortnote,
              slip_customer: this.editedItem.slip_customer,
              slip_image_url: this.editedItem.slip_image_url
            };
            const response = await axios.post(this.baseURL + "/addCustomerCourse", saveObj, {
              headers: { Authorization: `Bearer ${token}` },
            });
            if (response.data.success) {
              await this.handleUploadSlip(this.editedItem.slip_customer, response.data.courserefer);
              this.$emit("onInfoHandler", this.courseCreatedMsg(response.data.courserefer));
              this.copyToClipboard(response.data.courserefer);
            } else {
              this.$emit("onErrorHandler", response.data.message || this.$t('msg.addFail'));
            }
            this.initialize();
          }
        } catch (error) { // <--- เริ่ม catch block
          //console.error("Axios Post Error:", error); // <--- แสดง error ที่เกิดขึ้นใน console
          // คุณสามารถดูรายละเอียดของ error ได้จาก object `error`
          // เช่น error.response (ถ้า server ตอบกลับมาพร้อม error status)
          // หรือ error.request (ถ้า request ถูกส่งไปแต่ไม่ได้รับการตอบกลับ)
          // หรือ error.message
          if (error.response) {
            // Server ตอบกลับมาพร้อม error status (e.g., 4xx, 5xx)
            console.log("Error Response Data:", error.response.data);
            console.log("Error Response Status:", error.response?.status);
            console.log("Error Response Headers:", error.response.headers);
            this.$emit("onErrorHandler", error.response.data.message || this.$t("common.serverError"));
          } else if (error.request) {
            // Request ถูกส่งไปแต่ไม่ได้รับการตอบกลับ
            console.log("Error Request:", error.message);
            this.$emit("onErrorHandler", this.$t("common.noServerResponse") + " " + error.message);
          } else {
            // เกิดข้อผิดพลาดอื่นๆ ในการตั้งค่า request
            console.log("Error Message:", error.message);
            this.$emit("onErrorHandler", this.$t("common.errorPrefix") + ": " + error.message);
          }
        } finally { // <--- (ทางเลือก) finally block จะทำงานเสมอ ไม่ว่าจะมี error หรือไม่
          this.close();
          this.$emit("onLoading", false);
        }
        this.close();
        this.$emit("onLoading", false);
      } else {
          this.$emit('onErrorHandler', this.$t('msg.required'))
          this.$emit('onLoading', false)
          return
      }
    },
    */
    async save() {
      const { valid } = await this.$refs.courseform.validate();
      if (!valid) {
        this.$emit('onErrorHandler', this.$t('msg.required'));
        this.$emit('onLoading', false);
        return;
      }

      this.$emit("onLoading", true);
      const token = this.$store.getters.getToken;

      // แปลงวันที่ให้เป็นรูปแบบ SQL
      const startdate = this.editedItem.startdate ? this.SQLDate(this.editedItem.startdate) : null;
      const expiredate = this.editedItem.expiredate ? this.SQLDate(this.editedItem.expiredate) : null;
      const paydate = this.editedItem.paydate ? this.SQLDate(this.editedItem.paydate) : null;
      const shortnote = this.editedItem.shortnote || "";

      try {
        // สร้าง FormData
        const formData = new FormData();
        formData.append('courserefer', this.editedItem.courserefer || '');
        // ถ้า course เป็น object ให้แปลงเป็น JSON string ก่อนส่ง
        formData.append('coursestr', this.editedItem.course ? JSON.stringify(this.editedItem.course) : '');
        formData.append('courseid', this.editedItem.courseid || '');
        formData.append('coursetype', this.editedItem.coursetype);
        formData.append('remaining', this.editedItem.remaining);
        formData.append('startdate', startdate || '');
        formData.append('expiredate', expiredate || '');
        formData.append('period', this.editedItem.period);
        formData.append('enable_double_booking', this.editedItem.enable_double_booking ? 1 : 0);
        formData.append('paymentmethod', this.editedItem.paymentmethod || '');
        formData.append('is_promotion', this.editedItem.is_promotion ? 1 : 0);
        formData.append('paid', this.editedItem.paid);
        formData.append('paydate', paydate || '');
        formData.append('shortnote', shortnote);
        if (this.editedIndex > -1 && this.expiryChanged && this.expiryReason.trim()) formData.append('expiry_reason', this.expiryReason.trim());
        // ราคา ณ ตอนขาย — snapshot ตายตัว ไม่ผูกกับราคากลางอีกหลังจากบันทึกแล้ว
        formData.append('price', this.editedItem.price !== null && this.editedItem.price !== undefined ? this.editedItem.price : '');
        // ค่าธรรมเนียมการชำระเงิน — ส่งค่าที่โชว์อยู่บนหน้าจอเสมอ (0.00 ก็ส่ง) เพื่อให้สิ่งที่แอดมินเห็น
        // ตรงกับสิ่งที่บันทึกลงฐานข้อมูลเป๊ะ ๆ ถ้าไม่ส่ง server จะคำนวณให้เอง ซึ่งจะทับค่าที่แอดมินแก้เอง
        formData.append('payment_fee', this.editedItem.payment_fee !== null && this.editedItem.payment_fee !== undefined && this.editedItem.payment_fee !== '' ? this.editedItem.payment_fee : 0);
        // ลบสลิปที่ผู้ใช้กดลบค้างไว้ — เวลาที่ลบต่างกันตามเคส (ผลรีวิวก่อน ship 2026-08-23):
        //  • สลับใบ (ลบ + เพิ่มในครั้งเดียว) ต้องลบ **ก่อน** ส่งคำขอ ไม่งั้น backend นับเพดาน 3 ใบ
        //    จากของเดิมที่ยังไม่ถูกลบแล้วปฏิเสธ
        //  • ลบอย่างเดียว ให้รอจนบันทึกสำเร็จก่อน — ถ้าคำขอหลักพัง สลิปต้องไม่หายไปฟรี ๆ
        const preDelete = this.pendingSlipDeletes.length > 0 && this.pendingSlips.length > 0;
        if (preDelete) await this.flushSlipDeletes(token);
        formData.append('slip_image_url', this.editedItem.slip_image_url || '');
        // multi-slip: ใบใหม่แนบสลิปได้หลายไฟล์ในคำขอเดียว (field เดิม 'slipImage' — backend รับเป็น array)
        // ใบเดิมไม่ผ่านทางนี้แล้ว: SlipListPanel ยิง /addSlipImage เองทันทีที่เลือกไฟล์
        this.pendingSlips.forEach((file) => formData.append('slipImage', file));

        const url = this.editedIndex > -1
          ? this.baseURL + "/updateCustomerCourse"
          : this.baseURL + "/addCustomerCourse";

        const response = await axios.post(url, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            // ไม่ต้องกำหนด 'Content-Type' ให้ Axios จัดการเอง
          },
        });

        if (response.data.success) {
          // ลบอย่างเดียว: ลบตอนนี้ (บันทึกหลักผ่านแล้ว) — ยกเลิก dialog หรือบันทึกพัง = ไม่มีอะไรถูกลบ
          if (!preDelete) await this.flushSlipDeletes(token);
          // เส้นทางที่แนบสลิป (formData) — เหตุผลเดียวกับด้านบน: ข้อความสำเร็จต้องมาจาก $t() เท่านั้น
          const message = this.editedIndex > -1
            ? this.$t('msg.courseUpdated')
            : this.courseCreatedMsg(response.data.courserefer);

          // ผลตรวจสลิปจาก backend (SlipOK) — บันทึกสำเร็จเสมอ แต่ถ้าสลิปมีปัญหาให้เตือนแดงทันที
          const sv = response.data.slipVerification;
          if (sv && ['duplicate', 'wrong_receiver', 'amount_mismatch', 'failed'].includes(sv.status)) {
            this.$emit("onErrorHandler", `${this.$t('customerCourse.slipSaveWarn')}: ${sv.reason || sv.status}`);
          } else if (sv && sv.status === 'verified') {
            this.$emit("onInfoHandler", `${message} — ${this.$t('customerCourse.slipSaveVerified')}`);
          } else {
            this.$emit("onInfoHandler", message);
          }

          if (this.editedIndex === -1) {
            this.copyToClipboard(response.data.courserefer);
          }
        } else {
          const errorMsg = this.editedIndex > -1
            ? response.data.message || this.$t('msg.updateFail')
            : response.data.message || this.$t('msg.addFail');
          // สลิปถูกลบไปแล้วก่อนบันทึก (เคสสลับใบ) แต่บันทึกไม่ผ่าน — ต้องบอกตรง ๆ ไม่ใช่ปล่อยให้
          // ผู้ใช้เข้าใจว่า "ไม่มีอะไรเปลี่ยน" ทั้งที่สลิปเดิมหายไปแล้ว
          this.$emit("onErrorHandler", preDelete ? `${errorMsg} · ${this.$t('customerCourse.slipDeletedAnyway')}` : errorMsg);
        }

        this.initialize();
      } catch (error) {
        if (error.response) {
          console.log("Error Response Data:", error.response.data);
          this.$emit("onErrorHandler", error.response.data.message || this.$t("common.serverError"));
        } else if (error.request) {
          console.log("Error Request:", error.message);
          this.$emit("onErrorHandler", this.$t("common.noServerResponse") + " " + error.message);
        } else {
          console.log("Error Message:", error.message);
          this.$emit("onErrorHandler", this.$t("common.errorPrefix") + ": " + error.message);
        }
      } finally {
        this.close();
        this.$emit("onLoading", false);
      }
    },
    /*
    async handleUploadSlip(file, courserefer) {

      if (this.editedItem.slip_image_url && !file) {
          console.log('No new image to upload');
          return;
      }

      if (file) {
        const formData = new FormData();
        const newFileName = `${courserefer}.${file.name.split('.').pop()}`;

        // สร้างไฟล์ใหม่ด้วยชื่อไฟล์ใหม่
        const renamedFile = new File([file], newFileName, { type: file.type });

        formData.append("slipImage", renamedFile);
        formData.append("courserefer", courserefer);

        const response = await fetch(this.baseURL + '/uploadSlipImage', {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${this.token}`, // เพิ่ม token ลงใน headers
            },
            body: formData,
        });

        const data = await response.json();
        const imageUrl = data.url;
        console.log('imageUrl', imageUrl);
        
      }
    },
    */
    async getCourseLookup() {
      const token = this.$store.getters.getToken;
      await axios
        .get(this.baseURL + "/courseLookup", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          //console.dir(response);
          if (response.data.success) {
            this.courseLookup = response.data.results;
          }
        })
        .catch((error) => {
          if (error.response?.status == 401) {
            this.$emit("onErrorHandler", error.response.data.message);
            this.$emit("onClickChangeState", "login");
          } else {
            this.$emit("onErrorHandler", error.message);
          }
        });
    },
    // re-query from page 1 when a toolbar filter changes (server-side filter)
    applyFilter() { this.tableOptions.page = 1; this.getCustomerCourseList(); },
    // click a sortable header → cycle the server sortBy (none→asc→desc→none), reset to page 1, refetch.
    applySort(h) {
      if (h.sortable === false) return;
      this.tableOptions.sortBy = this.$toggleSort(this.tableOptions.sortBy, h.key);
      this.tableOptions.page = 1;
      this.getCustomerCourseList(true);
    },
    // animate = true only for grid page / per-page changes → ≥1s skeleton.
    // Menu-entry / search loads pass nothing → skeleton only for the real fetch.
    async getCustomerCourseList(animate = false) {
      this.loadingCustomerCourse = true;
      const t0 = Date.now();
      const token = this.$store.getters.getToken;
      const { page, itemsPerPage, sortBy } = this.tableOptions;
      await axios
        .post(
          this.baseURL + "/getCustomerCourseList",
          { page, itemsPerPage, search: this.search, sortBy, coursetype: this.filterCoursetype, paid: this.filterPaid, is_promotion: this.filterPromotion },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(async (response) => {
          if (response.data.success) {
            this.courselist = response.data.results ?? [];
            this.totalItems = response.data.total ?? 0;
          }
          if (animate) await this.$minLoad(t0);
          this.loadingCustomerCourse = false;
        })
        .catch(async (error) => {
          if (animate) await this.$minLoad(t0);
          this.loadingCustomerCourse = false;
          if (error.response?.status == 401) {
            this.$emit("onErrorHandler", error.response.data.message);
            this.$emit("onClickChangeState", "customercourse");
          } else {
            this.$emit("onErrorHandler", error.message);
          }
        });
    },
    onTableOptions({ page, itemsPerPage, sortBy }) {
      this.tableOptions = { ...this.tableOptions, page, itemsPerPage, sortBy };
      if (!this.isMounted) return;
      this.getCustomerCourseList();
    },
    onChangeStartDate() {
      //console.log("onChangeStartDate");
      this.editedItem.expiredate = null;
    },
    SQLDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    format_date(value) {
      if (value) {
        return moment(value).format("DD/MM/YYYY");
      }
    },
    // แสดง createdate/editdate (TIMESTAMP จาก backend) เป็นเวลาไทยคงที่ ไม่ขึ้นกับ timezone ของเครื่องผู้ใช้
    format_datetime(value) {
      return formatDateTimeBKK(value, "DD/MM/YYYY HH:mm");
    },
    expireDateLeft(value) {
        let result = "";
        if (value) {
            let remainingText = this.calExpireText(value);
            result = this.format_date(value) + " (" + remainingText + ")";
        }
        return result;
    },
    isExpiredDate(expdate) {
        if (!expdate) return false;
        return new Date(expdate) < new Date();
    },
    calExpireText(expdate) {
      if (!expdate) return '';
      const today = new Date();
      const expirationDate = new Date(expdate);
      let returnText = '';

      if (expirationDate < today) {
          returnText = this.$t('table.expired');
      } else {
          let years = expirationDate.getFullYear() - today.getFullYear();
          let months = expirationDate.getMonth() - today.getMonth();
          let days = expirationDate.getDate() - today.getDate();

          if (days < 0) {
              months -= 1;
              days += new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
          }
          if (months < 0) {
              years -= 1;
              months += 12;
          }

          if (years > 0) returnText += `${years} ${this.$t('table.yearAbbr')} `;
          if (months > 0) returnText += `${months} ${this.$t('table.monthAbbr')} `;
          if (days > 0) returnText += `${days} ${this.$t('table.dayAbbr')}`;
      }
      return returnText;
    },
    async showAddNewCustomerCourse() {
      this.$emit("onLoading", true);
      await this.getCustomerCourseList();
      await this.getCourseLookup();
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.feeManualOverride = false;
      this.courseHolders = null;      // ผู้ใช้ของใบก่อนห้ามไปโผล่ในใบถัดไป (เดิมค่านี้อยู่ใน
      this.courseEverUsed = null;     // editedItem จึงถูกล้างฟรีตอน Object.assign defaultItem)
      this.slipPreload = null;
      this.$emit("onLoading", false);
      this.dialog = true;
    },
  }
};
</script>
<style scoped>

/* ช่องค่าธรรมเนียมการชำระเงิน (.fee-wrap / .fee-btn / .fee-readonly) ย้ายไปอยู่ที่
   assets/istar-pages.css แล้ว เพราะ dialog จองคลาส Private ใช้ชุดเดียวกัน — แก้ที่เดียวขยับทั้งสองหน้า */

.highlighted-red {
  color: red;
}
.sticky-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: lightgray;
}

.sticky-footer {
  position: sticky;
  bottom: 0;
  z-index: 10;
  background-color: lightgray;
}

.scrollable-content {
  max-height: 950px;
  overflow-y: auto;
}
/* slip upload stays visible but is disabled (greyed + not clickable) until
   "จ่ายแล้ว" (paid) is ticked — higher specificity than the global .id-upload:hover */
.id-upload.is-disabled {
  opacity: .5;
  cursor: not-allowed;
  pointer-events: none;
}
</style>
